export enum Layout {
  Primary = 'PRIMARY',
  Minimal = 'MINIMAL',
}
